import { useFormaliteService } from '@europrocurement/l2d-domain';
import {
    DossierOpenSearchApiApiOpensearchGreffesGetCollectionRequest,
    DossierOpenSearchJsonldOpensearchDossierGreffeRead,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type DossierGreffe = DossierOpenSearchJsonldOpensearchDossierGreffeRead &
    Record<string, unknown>;

const useDossierGreffe = () => {
    const { dossierOpenSearchApi } = useFormaliteService();
    let searchTimeout: number | undefined;

    const searchDossierGreffe = (term: string): Promise<Array<DossierGreffe>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchTimeout);
            const requestParameters: DossierOpenSearchApiApiOpensearchGreffesGetCollectionRequest =
                { q: term };

            searchTimeout = setTimeout(() => {
                dossierOpenSearchApi
                    .apiOpensearchGreffesGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<DossierGreffe>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchDossierGreffe };
};

export default useDossierGreffe;
